import { NOOP } from '@/utils';
import { config } from 'CONFIG';

export enum EPlatform {
    IOS = 'IOS',
    Android = 'Android',
    RN = 'ReactNative',
    Web = 'Web'
}

type TRequestToAppCb = ( data: string ) => void;

export const registerHandler = ( name: string, callback: TRequestToAppCb ): void => {

    if ( config.client === 'IOS' ) {

        if ( !window.IOSCaller ) {

            window.IOSCaller = {};

        }
        if ( !window.responseToJS ) {

            window.responseToJS = function( name, data ) {

                window.IOSCaller[ name ]( data );

            };

        }

        window.IOSCaller[ name ] = callback;

    } else {

        window.WebViewJavascriptBridge.registerHandler( name, callback );

    }

};

export const requestToApp = ( func: string, data: Record<string, any> | undefined, callback?: TRequestToAppCb ): void => {

    const newData = JSON.stringify( data );
    if ( config.client === 'IOS' ) {

        registerHandler( func, callback ?? NOOP );
        window.webkit.messageHandlers[ func ].postMessage( newData );
        console.log( `IOS ${func} called` );

    } else {

        if ( window.WebViewJavascriptBridge ) {

            window.WebViewJavascriptBridge.callHandler( func, newData, callback ?? NOOP );

        }
        else {

            document.addEventListener(
                'WebViewJavascriptBridgeReady'
                , function() {

                    window.WebViewJavascriptBridge.callHandler( func, newData, callback ?? NOOP );

                },
                false
            );

        }

        console.log( `Android ${func} called` );

    }

};

export const getClient = (): EPlatform => {

    const ua = window.navigator.userAgent;
    if ( ua.includes( 'RCloud/Android' )) {

        return EPlatform.Android;

    } else if ( ua.includes( 'RCloud/IOS' )) {

        return EPlatform.IOS;

    } else if ( ua.includes( 'RCloud/RN' )) {

        return EPlatform.RN;

    } else {

        return EPlatform.Web;

    }

};

export const getToken = (): Record<string, any> => {

    let appMessage: Record<string, any> = {};
    function callback( data: string ): void {

        console.log( 'get token function' );
        const newData = window.JSON.parse( data );
        appMessage = newData;

    }
    requestToApp( 'getToken', {}, callback );
    return appMessage;

};

export const refreshToken = (): Record<string, any> => {

    let appMessage: Record<string, any> = {};
    function callback( data: string ): void {

        const newData = window.JSON.parse( data );
        appMessage = newData;

    }
    requestToApp( 'refreshToken', {}, callback );
    return appMessage;

};

export const requestToRN = ( cmd: string, message: Record<string, any> | string | number, callback?: ( data: string ) => void ): void => {

    const appMessage = {
        cmd,
        message
    };
    const appMessageStr = window.JSON.stringify( appMessage );
    window.ReactNativeWebView.postMessage( appMessageStr );
    callback?.( '' );

};
